import { CallbackLeadSource } from "@/gql/graphql";
import { MultiSelectFilter } from "@/lib/Components/DataTable/Filters/MultiSelectFilter";
import { useTranslations } from "use-intl";

const sources = [
  CallbackLeadSource.SupplierCancellation,
  CallbackLeadSource.IncompleteBooking,
  CallbackLeadSource.Waitlist,
  CallbackLeadSource.Manual,
];

export function CallbackLeadSourceFilter({
  selected,
  onChange,
}: {
  selected: CallbackLeadSource[];
  onChange: (newSources: CallbackLeadSource[]) => void;
}) {
  const t = useTranslations("callbackLead");

  const options = sources.map((source) => ({
    label: t(`source.${source}`),
    value: source,
  }));

  return (
    <MultiSelectFilter
      label={t("filters.source")}
      options={options}
      selected={selected}
      onChange={onChange}
    />
  );
}
